<div class="game-container padding-safe-top">
  <!-- Top Bar -->
  <div class="top-bar">
    <div class="score">{{translation.guess_the_hymn.score}}: {{ player1score }}</div>
    <div>
      🏆 {{topScore}}
    </div>
    <div class="hearts">
      <mat-icon *ngFor="let heart of hearts">{{ heart ? 'favorite' : 'favorite_border' }}</mat-icon>
    </div>
  </div>


  <app-game #player1 class="player1"
            [player]="1"
            [message]="player1Message"
            [enableHints]="true"
            (begin)="begin()"
            (exit)="onExitDecideOutcome()"
            (exitImmediate)="onExit()"
            (restart)="onRestart()"
            (optionSelected)="onPlayerOptionSelected($event)"
            [playButtonActive]="playButtonActive"
            (midiplay)="playMidi(0)"
            (midistop)="stopMidi()"
            (info)="openInfoDialog()"
  ></app-game>
</div>
